<!-- TVG-360: Emails and SMS — one table carrying both kinds of message, in both
     directions, with queued ones listed and marked Queued. The two send buttons
     sit in the header. What Send email does is exactly what it did before. -->
<div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]" data-testid="contact-messages-panel">
  <div class="flex flex-wrap items-center justify-between gap-3 px-5 py-4 sm:px-6 sm:py-5">
    <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Emails and SMS</h3>

    @if (communicationsEnabled) {
      <div class="flex flex-wrap items-center gap-2">
        <!-- TVG-360: a text can only go to a contact who has a mobile number and
             has agreed to texts. There is no text sending connected to this
             application yet, so the button states why it cannot be used rather
             than pretending to send. -->
        <button
          type="button"
          [disabled]="!canSendSms || !smsSendingAvailable"
          [title]="smsUnavailableReason"
          data-testid="contact-send-sms"
          class="inline-flex items-center rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]"
          (click)="openSms()">
          Send SMS
        </button>
        <app-button
          [type]="'button'"
          [style]="'primary'"
          [label]="'Send email'"
          data-testid="contact-send-an-email"
          (click)="openCompose()"
        ></app-button>
      </div>
    }
  </div>

  <div class="space-y-4 border-t border-gray-100 p-5 dark:border-gray-800 sm:p-6">
    @if (sentNotice) {
      <div
        data-testid="contact-sent-notice"
        class="rounded-lg border border-green-200 bg-green-50/70 px-3 py-2 text-theme-sm text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-300">
        {{ sentNotice }}
      </div>
    }

    @if (loadError) {
      <div class="rounded-md bg-error-50 p-3 text-theme-sm text-error-700">{{ loadError }}</div>
    }

    @if (sentEmails.length > 0) {
      <div class="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800">
        <table class="w-full text-left text-theme-sm">
          <thead class="bg-gray-100 text-theme-xs text-gray-500 dark:bg-white/[0.04] dark:text-gray-400">
            <tr>
              <th class="px-4 py-2.5 font-medium">Sent</th>
              <th class="px-4 py-2.5 font-medium">Subject</th>
              <th class="px-4 py-2.5 font-medium">Type</th>
              <th class="px-4 py-2.5 font-medium">Sent to</th>
              <th class="px-4 py-2.5 font-medium">Status</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (sentEmail of sentEmails; track sentEmail.id) {
              <tr class="text-gray-700 dark:text-gray-300">
                <td class="px-4 py-2.5 whitespace-nowrap">
                  <!-- TVG-359 leaves room here: a queued message reads when it
                       is due rather than when it was sent. -->
                  @if (sentEmail.status === 'queued') {
                    Queued for {{ sentEmail.sent_at | date: 'dd/MM/yyyy HH:mm' }}
                  } @else {
                    {{ sentEmail.sent_at | date: 'dd/MM/yyyy HH:mm' }}
                  }
                </td>
                <td class="px-4 py-2.5">{{ sentEmail.subject }}</td>
                <td class="px-4 py-2.5">{{ sentEmail.type_label }}</td>
                <td class="px-4 py-2.5">{{ sentEmail.recipient_email }}</td>
                <td class="px-4 py-2.5">
                  <span
                    class="inline-flex items-center rounded-full px-2.5 py-1 text-theme-xs font-medium"
                    [ngClass]="statusClasses(sentEmail)">
                    {{ sentEmail.status_label }}
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (hasMore) {
        <div class="flex justify-center">
          <app-button
            [type]="'button'"
            [style]="'secondary'"
            [label]="'Load more'"
            [disabled]="loading"
            (click)="loadMore()"
          ></app-button>
        </div>
      }
    } @else if (!loading && !loadError) {
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">Nothing has been sent to this contact yet.</p>
    }

    @if (loading) {
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">Loading messages…</p>
    }
  </div>
</div>

@if (communicationsEnabled) {
  <app-compose-email-modal
    [isOpen]="composeOpen"
    [fixedContact]="composeContact"
    (sent)="onSent()"
    (cancelled)="closeCompose()"
  ></app-compose-email-modal>
}
